import Splide from '@splidejs/splide';
if($('.splide-slider').length > 0){
        new Splide('.splide-slider',{
            mediaQuery: 'min',
            type   : 'loop',
            pagination: true,
            arrows: false,
            perPage: 1,
            perMove: 1,
            autoplay: true,
            reducedMotion: {
                interval: 4000,
                speed: 800,
                autoplay: "play"
              },
            breakpoints:{
                1200: {
                    arrows: true,
                    pagination: false,
                },
            }
          }).mount();
}
if($('.list-item-slide').length > 0){
  new Splide('.list-item-slide', {
    fixedWidth: '240px',
    drag   : 'free',
    gap    : '30px',
    mediaQuery: 'min',
    arrows: false,
    pagination: false,
    breakpoints:{
        768: {
            perPage: 2,
            fixedWidth: false,
            arrows: true
        },
        992: {
            destroy: true,
            gap    : '30px',
            arrows: false
        }
    }
}).mount();
}
setInterval(function(){ 
    if($(document).width()<768){
        var elem = $('.top-header-usp .active-point');
        $(elem).removeClass('active-point')
        if($(elem).next('li').length>0){
            $(elem).next('li').addClass('active-point');
        }else{
            $('.top-header-usp li').first().addClass('active-point');
        }

    }
}, 3000);